import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { OrdersSettingsInterface } from '@shared/components/trading/widgets/orders-widget/core/interfaces/orders-settings.interface'
import { DropdownColumnsOrdersStocksComponent } from '@shared/components/trading/widgets/orders-widget/orders-widget-actions/dropdowns/common/stocks/dropdown-columns-orders-stocks.component'
import { DropdownColumnsOrdersOptionsComponent } from '@shared/components/trading/widgets/orders-widget/orders-widget-actions/dropdowns/common/options/dropdown-columns-orders-options.component'
import { DropdownColumnsOrdersPostTradingComponent } from '@shared/components/trading/widgets/orders-widget/orders-widget-actions/dropdowns/common/post-trading/dropdown-columns-orders-post-trading.component'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { OptionOrderTypeEnum } from '@modules/options-module/orders/enums/option-order-type.enum'

@UseLocales({ ru, en })
@Component({
	selector: 'app-orders-widget-actions',
	templateUrl: './orders-widget-actions.component.html',
	styleUrl: './orders-widget-actions.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		DropdownColumnsOrdersStocksComponent,
		DropdownColumnsOrdersOptionsComponent,
		DropdownColumnsOrdersPostTradingComponent,
	],
})
export class OrdersWidgetActionsComponent {
	protected readonly optionOrderTypeEnum: typeof OptionOrderTypeEnum = OptionOrderTypeEnum

	public widget: InputSignal<WidgetInterface<OrdersSettingsInterface> | null> =
		input<WidgetInterface<OrdersSettingsInterface> | null>(null)
}
